const options = {
  5: "bg-pink-800/5",
  10: "bg-pink-800/10",
  25: "bg-pink-800/25",
  50: "bg-pink-800/50",
  75: "bg-pink-800/75",
  90: "bg-pink-800/90",
  100: "bg-pink-800",
};

const from = {
  5: "from-pink-800/5",
  10: "from-pink-800/10",
  25: "from-pink-800/25",
  50: "from-pink-800/50",
  75: "from-pink-800/75",
  90: "from-pink-800/90",
  100: "from-pink-800",
};

export default function getBackgroundPink800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
